import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=33f5a5ee"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=33f5a5ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports